import ServiceConfigs from 'service/config';
import { apiMutate } from '../../utils/mutation';
import { MutationUpdateUserArgs } from '../../types';
import { updateUsersMutation } from '../../mutations/user';

type useUpdateUserType = () => (variables: MutationUpdateUserArgs) => Promise<void>;

const useUpdateUser: useUpdateUserType = () => variables =>
  apiMutate({
    mutation: updateUsersMutation,
    requestHeaders: ServiceConfigs.getAuthorizationHeader(),
    variables,
  });

export default useUpdateUser;
